import QueuePage from "./QueuePage";
export default function Approval() {
  return <QueuePage status="MENUNGGU_APPROVAL" title="Antrean Approval" description="Klaim yang menunggu persetujuan atasan." testId="approval-page" />;
}
